import React from "react";
import { DragDropContext } from "@hello-pangea/dnd";

import TaskKanbanColumn from "./TaskKanbanColumn";
import useHorizontalDragScroll from "../hooks/useHorizontalDragScroll";

export default function TaskKanbanBoard({
  columns,
  loading,
  onDragEnd,
  onOpenTask,
  onCreateInColumn,
  onToggleDone,
  onDuplicate,
  onArchive,
  onDelete,
  allCardsExpanded,
  expandedTaskIds,
  onToggleTaskExpanded,
}) {
  const { scrollRef, isDraggingScroll, dragScrollHandlers } =
    useHorizontalDragScroll();

  if (loading) {
    return (
      <div className="flex flex-1 gap-5 overflow-hidden px-5 py-5">
        {[1, 2, 3, 4, 5, 6].map((item) => (
          <div
            key={item}
            className="h-[calc(100vh-230px)] w-[312px] shrink-0 animate-pulse rounded-3xl border border-white/15 bg-white/60 shadow-xl"
          />
        ))}
      </div>
    );
  }

  if (!columns?.length) {
    return (
      <div className="flex flex-1 items-center justify-center px-5 py-8">
        <div className="rounded-3xl border border-white/20 bg-white/90 px-8 py-7 text-center shadow-2xl backdrop-blur">
          <div className="text-5xl">✅</div>
          <h2 className="mt-3 text-xl font-bold text-slate-900">
            Aucune tâche
          </h2>
          <p className="mt-1 text-sm text-slate-500">
            Aucune colonne ne contient de carte avec ces filtres.
          </p>
        </div>
      </div>
    );
  }

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <div
        ref={scrollRef}
        {...dragScrollHandlers}
        className={`kanban-scrollbar-hidden flex flex-1 cursor-grab gap-5 overflow-x-auto overflow-y-hidden px-5 py-5 active:cursor-grabbing ${
          isDraggingScroll ? "select-none" : ""
        }`}
      >
        {(columns || []).map((column) => (
          <TaskKanbanColumn
            key={column.id}
            column={column}
            onOpenTask={onOpenTask}
            onCreateInColumn={onCreateInColumn}
            onToggleDone={onToggleDone}
            onDuplicate={onDuplicate}
            onArchive={onArchive}
            onDelete={onDelete}
            allCardsExpanded={allCardsExpanded}
            expandedTaskIds={expandedTaskIds}
            onToggleTaskExpanded={onToggleTaskExpanded}
          />
        ))}

        <div className="flex h-fit w-[312px] shrink-0 cursor-default flex-col gap-3 rounded-3xl border border-dashed border-white/25 bg-white/10 p-4 text-white/85 backdrop-blur">
          <div className="text-sm font-bold">Organisation des tâches</div>
          <p className="text-xs leading-relaxed text-white/60">
            Les colonnes correspondent aux applications. Déplace une carte pour
            changer son application ou son ordre manuel.
          </p>
        </div>
      </div>

      <style>{`
        .kanban-scrollbar-hidden {
          scrollbar-width: none;
          -ms-overflow-style: none;
        }

        .kanban-scrollbar-hidden::-webkit-scrollbar {
          display: none;
        }
      `}</style>
    </DragDropContext>
  );
}